// reducers/products.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  
  ApplyTemplateToProjectAction,
  ProjectContentActions,
  ProjectContentItemCreateActions,
  
} from './content.actions';

import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';
import { SystemProcess, SystemProcessLoadingStatus } from 'src/app/shared/models/system.models';
import { ClearCurrentProject } from '../projects.actions';


export interface OutlineTreeNode extends OutlineItem {
  children?: OutlineItem[];    // List of wallets within the wallet.
}

// export interface ProductsOfferState extends EntityState<OfferItem> {}
export interface ProjectContentState {
  outline: OutlineItem[];
  itemCreateProcess: SystemProcess;
  outlineProcess: SystemProcess;
  loaded: boolean;
  error: any;
}

// export const projectContentAdapter = createEntityAdapter<ProjectItem>();
// export const productOfferAdapter = createEntityAdapter<OfferItem>();

const initialState: ProjectContentState = {
  outline: [],
  itemCreateProcess: {
    status: 'none',
    error: null
  },
  outlineProcess: {
    status: 'none',
    error: null
  },
  loaded: false,
  error: null,
};

export const projectContentReducer = createReducer(
  initialState,

  // ? Products List Related
  

  on(ProjectContentActions.load, (state) => {
    return {
      ...state,
      loaded: false
    };
  }),
  on(ProjectContentActions.loadSuccess, (state, { contents }) => {
    return {
      ...state,
      loaded: true,
      outline: contents
    }
    }),
  on(ProjectContentActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
  })),



  // Content Item Create
  on(ProjectContentItemCreateActions.create, (state) => ({
    ...state,
    itemCreateProcess: {status: 'creating'}
  })),
  on(ProjectContentItemCreateActions.success, (state, { item }) => ({
    ...state,
    outline: addNodeRecursive(state.outline, item?.parent?.id, item),
    itemCreateProcess: {status: 'done'}
  })),
  on(ProjectContentItemCreateActions.failure, (state, { error }) => ({
    ...state,
    itemCreateProcess: {status: 'error', error: {error: error, processType: 'creating'}}
  })),



    // Apply Content Template
    on(ApplyTemplateToProjectAction.apply, (state) => ({
      ...state,
      outlineProcess: {status: 'applying_template'}
    })),
    on(ApplyTemplateToProjectAction.success, (state, { contents }) => ({
      ...state,
      outline: contents,
      outlineProcess: {status: 'done'}
    })),
    on(ApplyTemplateToProjectAction.failure, (state, { error }) => ({
      ...state,
      outlineProcess: {status: 'error', error: {error: error, processType: 'applying_template'}}
    })),


  on(ClearCurrentProject, (state) => initialState)
);


const addNodeRecursive = (nodes: OutlineTreeNode[], parentId: number, node: OutlineTreeNode): OutlineTreeNode[] => {
  if (!parentId) {
    return [...nodes, node];
  }
  return nodes.map(n => {

    // Add node if parent is found
    if (n.id === parentId) {
      return { ...n, children: [...(n.children || []), node] };
    } else if (n.children) {
      return { ...n, children: addNodeRecursive(n.children, parentId, node) };
    } else {
      return n;
    }


  });
};

const updateNodeRecursive = (nodes: OutlineTreeNode[], node: OutlineTreeNode): OutlineTreeNode[] => {
  return nodes.map(n => {
    if (n.id === node.id) {
      return { ...node, children: n.children };  // Preserve existing children
    } else if (n.children) {
      return { ...n, children: updateNodeRecursive(n.children, node) };
    } else {
      return n;
    }
  });
};

const deleteNodeRecursive = (nodes: OutlineTreeNode[], nodeId: number): OutlineTreeNode[] => {
  return nodes.filter(n => n.id !== nodeId).map(n => {
    return {
      ...n,
      children: n.children ? deleteNodeRecursive(n.children, nodeId) : [],
    };
  });
};